import { Card } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Badge } from '../components/ui/badge';
import { Clock, DollarSign, Wrench } from 'lucide-react';

export default function ServiceCard({ service, onBook, onEdit, onDelete }) {
  return (
    <Card className="glass-card border-border p-5 hover:bg-muted/20 transition-colors" data-testid={`service-card-${service.service_id}`}>
      <div className="flex items-start justify-between gap-3">
        <div className="flex-1 min-w-0">
          <h3 className="font-medium text-base truncate">{service.title}</h3>
          {service.category && (
            <Badge variant="outline" className="mt-1 text-xs capitalize">{service.category}</Badge>
          )}
        </div>
        {service.price != null && (
          <div className="text-right flex-shrink-0">
            <p className="font-bold text-lg text-secondary">${service.price}</p>
            {service.price_type && <p className="text-xs text-muted-foreground capitalize">{service.price_type}</p>}
          </div>
        )}
      </div>

      {service.description && (
        <p className="mt-2 text-sm text-muted-foreground line-clamp-2">{service.description}</p>
      )}

      <div className="flex items-center gap-4 mt-3 text-xs text-muted-foreground">
        {service.duration && (
          <span className="flex items-center gap-1"><Clock className="w-3 h-3" />{service.duration}</span>
        )}
        {service.includes && service.includes.length > 0 && (
          <span className="flex items-center gap-1"><Wrench className="w-3 h-3" />{service.includes.length} included</span>
        )}
      </div>

      {service.includes && service.includes.length > 0 && (
        <div className="flex flex-wrap gap-1.5 mt-2">
          {service.includes.map((item, i) => (
            <Badge key={i} variant="secondary" className="text-xs">{item}</Badge>
          ))}
        </div>
      )}

      <div className="flex items-center gap-2 mt-4">
        {onBook && (
          <Button size="sm" onClick={onBook} data-testid={`book-service-${service.service_id}`}>
            Book Now
          </Button>
        )}
        {onEdit && (
          <Button size="sm" variant="outline" onClick={() => onEdit(service)}>Edit</Button>
        )}
        {onDelete && (
          <Button size="sm" variant="ghost" className="text-red-500" onClick={() => onDelete(service.service_id)}>Delete</Button>
        )}
      </div>
    </Card>
  );
}
